import React from 'react';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import Product from '../RelatedProducts/Product';
import PropTypes from 'prop-types';
import { localiseUrl } from 'src/common/utils/format-localised-url';

import './CrossSell.scss';

const CrossSell = props => {
  if (!props.showPartialOnMobile && props.media.desktopDown) {
    return null;
  }
  return (
    <section className="cross-sell">
      <div className="container-guttered">
        <div className="cross-sell-title-wrapper">
          <h4 className="text-base cross-sell-title">{props.title}</h4>
          {props.ctaLink && props.ctaText &&
            <a
              href={localiseUrl(props.model.countryModel, props.ctaLink)}
              className="text-milli cross-sell-cta">
              {props.ctaText}
            </a>
          }
        </div>
        <Row>
          {props.items.map((item, i) => (
            <Col
              className="cross-sell-column"
              key={item.productSlug}>
              <Product
                key={i}
                image={item.image}
                productTitle={item.title}
                slug={item.productSlug}
                ageRangeLabel={props.model.prismicGlobalContentModel.general.ageRangeLabel}
                price={item.price}
                maximumAge={item.maximumAge}
                minimumAge={item.minimumAge}
                description={item.description}
                itemsCount={props.items.length}
                isDesktop={props.media.desktopUp}
                savings={item.savings}
                showPrice={props.showPrice}
              />
            </Col>
          ))}
        </Row>
      </div>
    </section >
  );
};


CrossSell.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  savings: PropTypes.object,
  showPrice: PropTypes.bool,
  showPartialOnMobile: PropTypes.bool,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  media: PropTypes.shape({
    desktopUp: PropTypes.bool,
    desktopDown: PropTypes.bool
  }),
  model: PropTypes.shape({
    countryModel: PropTypes.object,
    prismicGlobalContentModel: PropTypes.shape({
      general: PropTypes.shape({
        ageRangeLabel: PropTypes.string
      })
    })
  })
};

export default CrossSell;





// WEBPACK FOOTER //
// ./src/client/js/view/components/CrossSell/CrossSell.js